import { useTranslation } from 'react-i18next'

import { Button, Modal, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ErrorDeleteGroupModal = ({ show, onClose }) => {
  const { t } = useTranslation()

  return (
    <Modal title={t('No se puede eliminar este grupo')} size="l" onClose={onClose} show={show}>
      <Styles.Container>
        <Text type="bodyMRegular">
          {t(
            'No podrás eliminar el único grupo creado si hay usuarios asociados. Crea otros grupos y reasigna a los usuarios para poder eliminar este grupo.'
          )}
        </Text>
        <Styles.ActionsContainer>
          <Button onClick={onClose} fullWidth>
            {t('Entendido')}
          </Button>
        </Styles.ActionsContainer>
      </Styles.Container>
    </Modal>
  )
}

export default ErrorDeleteGroupModal
